import React, { Component } from 'react'
import { Grid, Button } from "@material-ui/core";

class LinkPane extends Component {
  openInNewTab = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  render() {
    return (
      <Grid container spacing={1} justify="center" alignItems="center">
        <Grid item>
          <Button variant="text" onClick={() => this.openInNewTab('http://link1.com')} style={{ color: 'white' }}>Paper</Button>
        </Grid>
        <Grid item>
          <Button variant="text" onClick={() => this.openInNewTab('http://link2.com')} style={{ color: 'white' }}>Data</Button>
        </Grid>
        <Grid item>
          <Button variant="text" onClick={() => this.openInNewTab('http://link3.com')} style={{ color: 'white' }}>Code</Button>
        </Grid>
      </Grid>
    )
  }
}

export default React.memo(LinkPane)
